import { ISrcSet } from '@helpers/types'
import React, { FC } from 'react'
import { Avatar } from '@components/UIKit/Avatar/Avatar'
import { useGetPublicProfile } from '@hooks/TRPC_Hooks/useGetPublicProfile'
import { profile } from '@specs/specs'

export interface Props {
    shortId: profile['shortid']
    srcSet: Omit<ISrcSet, 'avatarId'>[]
    className?: string
}

const ArtistAvatarMemo: FC<Props> = ({
    shortId,
    srcSet,
    className,
}) => {
    const { data: profile, isLoading: profileLoading } = useGetPublicProfile({ shortId })
    const isLoading = profileLoading

    return (
        <Avatar
            srcSet={srcSet}
            shortId={shortId}
            profile={profile}
            isLoading={isLoading}
            className={className}
        />
    )
}

export const ArtistAvatar = React.memo(ArtistAvatarMemo)
